module.exports = __webpack_public_path__ + "img/909.61e231b0.png";